export const KMT_PATH_KEYS = {
  PROPOSAL_ID: "proposalId",
  // PROPOSAL_TYPE: "proposalType"
}

const KNOWLEDGE_MANAGEMENT_ASSOCIATE_ROUTES = {
  CIP: "cip",
  ADD_CLIENT: "add_edit_form",
  RFP: "request_for_proposals",
  PROPOSAL_DETAIL: `:${KMT_PATH_KEYS.PROPOSAL_ID}`,
  REQUEST_FOR_PROPOSAL_FOR_END_CLIENT: "request_for_proposal_end_client",
  EMPLOYEE_CENTER: "employee_center",
  CRP_CLIENTS:"crp_clients",
  COLLABORATION_CENTER:"/collaboration_center",
  CHANGE_CLIENT_PM : "/change_client_pm",
  ADD_COLLABORATION_DETAIL:"add_collaboration_details",
  ADD_NEW_COLLABORATION:"add_new_collaboration",
}


export default Object.freeze(KNOWLEDGE_MANAGEMENT_ASSOCIATE_ROUTES)
